import * as React from "react";
import auth from "../../../Auth";
import globalAdminService from "../../../Admin/GlobalAdmin/Service/DataService";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import withValueField from "../../../Shared/withValueField";
import { IDropDownModel } from "../../../Shared/Models/IDropDownModel";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { filterBy } from "@progress/kendo-data-query";
import { history, addDays, errorToastr, successToastr } from "../../../../HelperMethods";
import _ from "lodash";
import ConfirmationModal from "../../../Shared/ConfirmationModal";
import { ASSIGN_SCHEDULE_CONFIRMATION_MSG, GENERATE_SCHEDULE_CONFIRMATION_MSG, PUBLISH_SCHEDULE_CONFIRMATION_MSG, SCHEDULE_GENERATED_SUCCESS_MSG, SCHEDULE_PUBLISHED_SUCCESS_MSG, SELECT_POSITION_TO_GENERATE_SCHEDULE, SELECT_POSITION_TO_PUBLISH_SCHEDULE } from "../../../Shared/AppMessages";
import { ErrorComponent } from "../../../ReusableComponents";
import { isNullCheck, isNullObjCheck } from "../../Common/Helper";
import Service from "../../Service/Service";
import { Dialog } from "@progress/kendo-react-dialogs";
import CreateShift from "../Shift/CreateShift";
import AssignScheduleShift from "../../../AssignSchedule/AssignScheduleShift";
import { AppPermissions } from "../../../Shared/Constants/AppPermissions";
import { LocalizationHelper } from "../../../../Localization/helpers/LocalizationHelper";
import { LocalizationResource } from "../../../Shared/AppConstants";

const CustomDropDownList = withValueField(DropDownList);

const defaultDivision = { name: "Select...", divisionId: null };
const defaultLocation = { name: "Select...", locationId: null };
const defaultDepartment = { name: "Select...", departmentId: null };
const defaultSchedule = { scheduleName: "Select...", scheduleId: null };

export interface SchedulerFilterInfoProps {
    scheduleId: any;
    deptId?: any;
    isIdsLoaded?: any;
    data?: any;
    dropdownDisable?: boolean;
    handleObjChange?: any;
    handleGetSchedule?: any;
}

export interface SchedulerFilterInfoState {
    clientId: string;
    clientName: string;
    divisions: any;
    originaldivisions: Array<IDropDownModel>;
    locations: any;
    originallocations: Array<IDropDownModel>;
    departments: any;
    originaldepartments: Array<IDropDownModel>;
    schedules: any;
    originalschedules: Array<IDropDownModel>;
    positions: any;
    originalpositions: Array<IDropDownModel>;
    jobCategories: any;
    originaljobCategories: Array<IDropDownModel>;
    startDate?: Date;
    endDate?: Date;
    showPublishModal: boolean;
    submitted: boolean;
    showAddShiftModal: boolean;
    showAssignModal: boolean;
    showLoader?: boolean;
    showGenerateConfirmationModal?: boolean;
    showPublishConfirmationModal?: boolean;
    showAsignConfirmationModal?: boolean;

    //Filter Params
    scheduleId?: string;
}

export enum ALLSELECTED {
    ALLDIVISIONS = "All Divisions",
    ALLLOCATIONS = "All Locations",
    ALLCATEGORIES = "All Categories",
    ALLPOSITIONS = "All Positions",
}

class FilterInformation extends React.Component<SchedulerFilterInfoProps, SchedulerFilterInfoState> {
    constructor(props: SchedulerFilterInfoProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            clientName: auth.getClientName(),
            divisions: [],
            locations: [],
            departments: [],
            schedules: [],
            jobCategories: [],
            positions: [],
            originaldivisions: [],
            originallocations: [],
            originaldepartments: [],
            originalschedules: [],
            originaljobCategories: [],
            originalpositions: [],
            startDate: new Date(),
            endDate: addDays(new Date(), 30),
            showPublishModal: false,
            submitted: false,
            showAddShiftModal: false,
            showAssignModal: false,
            showLoader: false,
            showGenerateConfirmationModal: false,
            showPublishConfirmationModal: false,
            showAsignConfirmationModal: false
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        const { locationId, departmentId, scheduleId } = this.props.data;
        this.getLocations(locationId);
        this.getJobCategory();

        if (this.props.scheduleId && this.props.deptId) {
            this.setState({
                scheduleId: this.props.scheduleId,
            });
            let queryParams = `scheduleId eq ${this.props.scheduleId}`;
            Service.getSchedulesLookup(queryParams).then((res) => {
                this.getSchedules(res.data[0].departmentId, this.state.scheduleId);
                this.getDepartments(res.data[0].locationId, res.data[0].departmentId);
            });
        }
    }

    getDepartments(locationId, departmentId) {
        let queryParams = `locId eq ${locationId} and status eq 'Active' &$orderby=name`;
        Service.getDepartments(queryParams).then((res) => {
            this.setState({ departments: res.data, originaldepartments: res.data }, () => {
                if (this.props.scheduleId && this.props.deptId) {
                    this.props.handleObjChange({
                        departmentId: departmentId
                    });
                } else {
                    this.props.handleObjChange({ departmentId: null, scheduleId: null });
                }
            });
        });
    }

    getSchedules(id, scheduleId) {
        let queryParams = `departmentId eq ${id}`;
        Service.getSchedulesLookup(queryParams).then((res) => {
            this.setState({ schedules: res.data, originalschedules: res.data }, () => {
                if (this.props.scheduleId && this.props.deptId) {
                    this.props.handleObjChange({
                        scheduleId: scheduleId
                    });
                } else {
                    this.props.handleObjChange({ scheduleId: null });                    
                }
            });
        });
    }

    getDivisions = () => {
        let queryParams = `status eq 'Active'&$orderby=name`;
        if (this.props.data.divisionId) {
            queryParams = `status eq 'Active' or divisionId eq ${this.props.data.divisionId} &$orderby=name `;
        }
        Service.getClientDivision(queryParams).then((res: any) => {
            this.setState({ divisions: res.data, originaldivisions: res.data });

        });
    };

    getLocations = (locationId) => {
        let queryParams = `clientId eq ${this.state.clientId} and status eq 'Active' &$orderby=name`;
        if (locationId) {
            queryParams = `clientId eq ${this.state.clientId} and LocationId eq ${locationId} and status eq 'Active' &$orderby=name`;
        }

        Service.getLocations(queryParams).then((res: any) => {
            this.setState({ locations: res.data, originallocations: res.data });
        });
    };

    getJobCategory = () => {
        const { clientId } = this.state;
        const queryParams = `status eq 'Active'&$orderby=name`;

        globalAdminService
            .getClientPositionCategories(clientId, queryParams)
            .then(async (res: any) => {
                res.data.unshift({
                    name: ALLSELECTED.ALLCATEGORIES,
                    jobCategoryIntId: 9999,
                });
                this.setState({
                    jobCategories: res.data,
                    originaljobCategories: res.data,
                });
            });
    };

    getPositions = (Ids, defaultAll) => {
        Service.getJobcatpositions(this.state.clientId, Ids)
            .then(async (res: any) => {
                res.data.unshift({
                    name: ALLSELECTED.ALLPOSITIONS,
                    clientPosMapIntId: 9999,
                });
                this.setState({ positions: res.data, originalpositions: res.data });
                if (defaultAll) {
                    var selectedPos = res.data;
                    selectedPos = selectedPos.filter(
                        (x) => x.id != undefined && x.id != null && x.clientPosMapIntId != 9999
                    );
                    this.props.handleObjChange({
                        selectedPositions: selectedPos,
                        isAllJobPosSelected: true,
                    });
                }
                else {
                    let originalPositions = this.state.positions.map((x) => x.id);
                    let selectedPositions = this.props.data.selectedPositions.filter((x) => originalPositions.indexOf(x.id) != -1)
                    this.props.handleObjChange({
                        selectedPositions: selectedPositions
                    });
                }
            });
    };

    handleDateChange = (e) => {
        if (e.target != undefined && (e.target.name == 'startDate' || e.target.name == 'endDate')) {
            let changes = {};
            changes[e.target.name] = e.target.value;
            this.setState(changes);
            this.props.handleObjChange({
                [e.target.name]: e.target.value
            });
        } else {
            let change = {};
            change[e.target.name] = e.target.value;
            this.setState(change);
            this.props.handleObjChange({
                [e.target.name]: e.target.value
            });
        }
    };

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const originalData = this.state[originalArray];
        return filterBy(originalData, filter);
    }

    itemRender = (li, itemProps) => {
        const itemChildren = (
            <span>
                <input
                    type="checkbox"
                    checked={itemProps.dataItem.name == "All Divisions" ? this.props.data.isAllDivSelected :
                        itemProps.dataItem.name == "All Locations" ? this.props.data.isAllLocSelected :
                            itemProps.dataItem.name == "All Categories" ? this.props.data.isAllJobCatSelected :
                                itemProps.dataItem.name == "All Positions" ? this.props.data.isAllJobPosSelected :
                                    itemProps.selected}
                    onChange={(e) => itemProps.onClick(itemProps.index, e)}
                />
                &nbsp;{li.props.children}
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    handleDivisionChange = (e) => {
        const id = e.value.divisionId;
        if (id) {
            this.getLocations(id);
        }
        else {
            this.setState({ locations: [], originallocations: [] });
        }
        this.props.handleObjChange({ divisionId: id });
    }


    handleLocationChange = (e) => {
        const id = e.value.locationId;
        if (id) {
            this.props.handleObjChange({ locationId: id, departmentId: null, scheduleId: null, isIdsLoaded: false });
            this.setState({ schedules: [], originalschedules: [] });
            this.getDepartments(id, this.props.data.departmentId);
        }
        else {
            this.setState({ departments: [], originaldepartments: [], schedules: [], originalschedules: [] });
            this.props.handleObjChange({ locationId: null, departmentId: null, scheduleId: null, isIdsLoaded: false });
        }									   
    }

    handleDepartmentChange = (e) => {
        const id = e.value.id;
        if (id) {
            this.props.handleObjChange({ departmentId: id, scheduleId: null, isIdsLoaded: false });
            this.getSchedules(id, this.props.data.scheduleId);
        }
        else {
            this.setState({ schedules: [], originalschedules: [] });
            this.props.handleObjChange({ departmentId: null, scheduleId: null, isIdsLoaded: false });
        }											 
    }

    handleScheduleChange = (e) => {
        const id = e.value.scheduleId;
        if (id) {
            this.setState({ scheduleId: id });
            this.props.handleObjChange({ scheduleId: id });
            this.props.handleGetSchedule(e.value.scheduleId);
        }else {
            this.props.handleObjChange({ scheduleId: null, isIdsLoaded: false });
        }
    }

    handleJobCategoryChange = (e) => {
        var isAllSelected = false;
        var selectedJobCat = e.value.filter(
            (x) => x.id != undefined && x.id != null && x.jobCategoryIntId != 9999
        );
        let Id = selectedJobCat.map((jobCat) => jobCat.id);

        if (e.nativeEvent.target.innerText?.trim() === ALLSELECTED.ALLCATEGORIES
            || (e.nativeEvent.target.nextSibling != null && e.nativeEvent.target.nextSibling.nextSibling != null
                && e.nativeEvent.target.nextSibling.nextSibling.wholeText != null && e.nativeEvent.target.nextSibling.nextSibling.wholeText != undefined
                && e.nativeEvent.target.nextSibling.nextSibling.wholeText?.trim() === ALLSELECTED.ALLCATEGORIES)) {
            if (!this.props.data.isAllJobCatSelected) {
                isAllSelected = true;
                var jobCats = this.state.jobCategories.filter(
                    (x) => x.id != undefined && x.id != null && x.jobCategoryIntId != 9999
                );

                Id = jobCats.map((jobCat) => jobCat.id);
                selectedJobCat = this.state.jobCategories;
            } else {
                selectedJobCat = [];
                Id = null;
            }
        } else {
            if (selectedJobCat.length == (this.state.jobCategories.length - 1)) {
                selectedJobCat.unshift({ name: ALLSELECTED.ALLCATEGORIES, jobCategoryIntId: 9999 });
                isAllSelected = true;
            }
        }

        this.props.handleObjChange({
            selectedJobCategory: selectedJobCat,
            isAllJobCatSelected: isAllSelected,
        });

        if (Id != null && Id.length > 0) {
            this.getPositions(Id ,false);
        } else {
            this.setState({ positions: [] });
            this.props.handleObjChange({
                selectedPositions: []
            });
        }
    };


    handlePositionChange = (e) => {
        var isAllSelected = false;
        var selectedPos = e.value.filter(
            (x) => x.id != undefined && x.id != null && x.clientPosMapIntId != 9999
        );
        let Id = selectedPos.map((pos) => pos.id);

        if (e.nativeEvent.target.innerText?.trim() === ALLSELECTED.ALLPOSITIONS
            || (e.nativeEvent.target.nextSibling != null && e.nativeEvent.target.nextSibling.nextSibling != null
                && e.nativeEvent.target.nextSibling.nextSibling.wholeText != null && e.nativeEvent.target.nextSibling.nextSibling.wholeText != undefined
                && e.nativeEvent.target.nextSibling.nextSibling.wholeText?.trim() === ALLSELECTED.ALLPOSITIONS)) {
            if (!this.props.data.isAllJobPosSelected) {
                isAllSelected = true;
                var pos = this.state.positions.filter(
                    (x) => x.id != undefined && x.id != null && x.clientPosMapIntId != 9999
                );

                Id = pos.map((loc) => loc.id);
                selectedPos = this.state.positions;
            } else {
                selectedPos = [];
                Id = null;
            }
        } else {
            if (selectedPos.length == (this.state.positions.length - 1)) {
                selectedPos.unshift({ name: ALLSELECTED.ALLPOSITIONS, clientPosMapIntId: 9999 });
                isAllSelected = true;
            }
        }

        this.props.handleObjChange({
            selectedPositions: selectedPos,
            isAllJobPosSelected: isAllSelected,
        });
    };

    showGenerateModal = () => {
        this.setState({ showGenerateConfirmationModal: true });
    }

    showPublishModal = () => {
        this.setState({ showPublishConfirmationModal: true });
    }

    showAsignModal = () => {
        this.setState({ showAsignConfirmationModal: true });
    }

    ScheduleFilterValidation = (schType) => {

        var scheduleId = this.props.data.scheduleId;
        var jobCatIds = this.props.data.selectedJobCategory.map((x) => x.id);
        var PosIds = this.props.data.selectedPositions.map((x) => x.id);

        if (!isNullObjCheck(jobCatIds) || !isNullObjCheck(PosIds)) {
            if (schType == 1) {
                errorToastr(SELECT_POSITION_TO_GENERATE_SCHEDULE);
            } else if (schType == 2) {
                errorToastr(SELECT_POSITION_TO_PUBLISH_SCHEDULE);

            }
            return;
        }

        if (schType == 1) {
            this.setState({ showGenerateConfirmationModal: true });
        } else if (schType == 2) {
            this.setState({ showPublishConfirmationModal: true });
        }
    }

    generateSchedule = () => {
        this.setState({ showGenerateConfirmationModal: false });
        let data = {
            scheduleId: this.props.data.scheduleId,
            positionIds: this.props.data.selectedPositions.map((x) => x.id),
            StateDate: this.state.startDate,
            endDate: this.state.endDate,
        };

        Service.patchGenerateSchedule(data).then((res) => {
            successToastr(SCHEDULE_GENERATED_SUCCESS_MSG);
            this.props.handleGetSchedule(this.props.data.scheduleId);
        });
    }

    publishSchedule = () => {
        this.setState({ showPublishConfirmationModal: false });
        let data = {
            scheduleId: this.props.data.scheduleId,
            positionIds: this.props.data.selectedPositions.map((x) => x.id),
            StateDate: this.state.startDate,
            endDate: this.state.endDate,
        };

        Service.postPublishSchedule(data).then((res) => {
            successToastr(SCHEDULE_PUBLISHED_SUCCESS_MSG);
            this.props.handleGetSchedule(this.props.data.scheduleId);
        });
    }

    assignSchedule = () => {
        this.setState({ showPublishConfirmationModal: false });
    }

    render() {
        const {
            divisions, originaldivisions,
            locations, originallocations,
            departments, originaldepartments,
            schedules, originalschedules,
            positions, originalpositions,
            jobCategories, originaljobCategories,
            startDate, endDate
        } = this.state;
        const { isIdsLoaded } = this.props;

        const { divisionId, locationId, departmentId, scheduleId, selectedJobCategory, selectedPositions } = this.props.data;
        const { dropdownDisable } = this.props;
        return (
            <div className="">
                <div className="row">
                    <div className="col-12 pl-0 pr-0">
                        {!isIdsLoaded &&
                            Array.from({ length: 4 }).map((item, i) => (
                                <div className="row mx-auto mt-2" key={i}>
                                    {Array.from({ length: 3 }).map((item, j) => (
                                        <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                            <Skeleton width={100} />
                                            <Skeleton height={30} />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        {isIdsLoaded && (
                            <div>
                                <div className="row mt-2 mx-0">
                                    {/* <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                        <label className="mb-1 font-weight-bold required">Division</label>
                                        <CustomDropDownList
                                            className={"form-control disabled"}
                                            disabled={dropdownDisable}
                                            data={divisions}
                                            name="divisionId"
                                            textField="name"
                                            valueField="divisionId"
                                            id="divisions"
                                            value={divisionId}
                                            defaultItem={defaultDivision}
                                            onChange={(e) => this.handleDivisionChange(e)}
                                            filterable={originaldivisions.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {divisionId && <ErrorComponent />}
                                    </div> */}
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                        <label className="mb-1 font-weight-bold required">{LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}</label>
                                        <CustomDropDownList
                                            className={"form-control disabled"}
                                            disabled={dropdownDisable}
                                            data={locations}
                                            name="locationId"
                                            textField="name"
                                            valueField="locationId"
                                            id="locations"
                                            value={locationId}
                                            defaultItem={defaultLocation}
                                            onChange={(e) => this.handleLocationChange(e)}
                                            filterable={originallocations.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {!isNullCheck(locationId) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                        <label className="mb-1 font-weight-bold required">{LocalizationHelper.getLocalizedTitle(LocalizationResource.Department_Label, "Department")}</label>
                                        <CustomDropDownList
                                            className={"form-control disabled"}
                                            disabled={dropdownDisable}
                                            data={departments}
                                            name="departmentId"
                                            textField="name"
                                            valueField="id"
                                            id="departments"
                                            value={departmentId}
                                            defaultItem={defaultDepartment}
                                            onChange={(e) => this.handleDepartmentChange(e)}
                                            filterable={originaldepartments.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {!isNullCheck(departmentId) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                        <label className="mb-1 font-weight-bold required">Schedule</label>
                                        <CustomDropDownList
                                            className={"form-control disabled"}
                                            disabled={dropdownDisable}
                                            data={schedules}
                                            name="scheduleId"
                                            textField="scheduleName"
                                            valueField="scheduleId"
                                            id="schedules"
                                            value={scheduleId}
                                            defaultItem={defaultSchedule}
                                            onChange={(e) => this.handleScheduleChange(e)}
                                            filterable={originalschedules.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {!isNullCheck(scheduleId) && <ErrorComponent />}
                                    </div>
                                </div>
                                <div className="row mt-3 mx-0">
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1 multiselect">
                                        <label className="mb-1 font-weight-bold required">
                                            Job Category
                                        </label>
                                        <MultiSelect
                                            className="form-control"
                                            data={jobCategories}
                                            textField="name"
                                            dataItemKey="id"
                                            id="jobCategories"
                                            itemRender={this.itemRender}
                                            autoClose={false}
                                            value={selectedJobCategory.filter((x) => x.jobCategoryIntId != 9999)}
                                            onChange={(e) => this.handleJobCategoryChange(e)}
                                            placeholder="Select Job Category..."
                                            filterable={originaljobCategories.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {!isNullCheck(selectedJobCategory) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                        <label className="mb-1 font-weight-bold required">Position</label>
                                        <MultiSelect
                                            className="form-control"
                                            data={positions}
                                            textField="name"
                                            dataItemKey="id"
                                            id="positions"
                                            itemRender={this.itemRender}
                                            autoClose={false}
                                            value={selectedPositions.filter((x) => x.clientPosMapIntId != 9999)}
                                            onChange={(e) => this.handlePositionChange(e)}
                                            placeholder="Select Positions..."
                                            filterable={originalpositions.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {!isNullCheck(selectedPositions) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-4 col-lg-4">
                                        <div className="row">
                                            <div className="col-6 pr-sm-1">
                                                <label className="mb-1 font-weight-bold required">Start Date</label>
                                                <DatePicker
                                                    className="form-control"
                                                    format="MM/dd/yyyy"
                                                    name="startDate"
                                                    value={startDate}
                                                    onChange={(e) => this.handleDateChange(e)}
                                                    formatPlaceholder="formatPattern"
                                                    min={new Date()}
                                                    max={endDate ? new Date(new Date(endDate).setDate(new Date(endDate).getDate() - 1)) : new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                                                />
                                            </div>
                                            <div className="col-6 pl-sm-1">
                                                <label className="mb-1 font-weight-bold required">End Date</label>
                                                <DatePicker
                                                    className="form-control"
                                                    format="MM/dd/yyyy"
                                                    name="endDate"
                                                    value={endDate}
                                                    onChange={(e) => this.handleDateChange(e)}
                                                    formatPlaceholder="formatPattern"
                                                    min={new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1))}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-end border-0 mt-1">
                                    <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-end">
                                        {auth.hasPermissionV2(AppPermissions.SCHEDULE_GENERATE) && (
                                            <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={() => this.ScheduleFilterValidation(1)}>
                                                <FontAwesomeIcon icon={faCheckCircle} className={"mr-1"} /> Generate Schedule
                                            </button>
                                        )}
                                        {auth.hasPermissionV2(AppPermissions.SCHEDULE_SHIFT_CREATE) && (
                                            <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={
                                                () => {
                                                        document.body.classList.remove("scheduler-shift-wrap");
                                                        this.setState(
                                                            {
                                                                showAddShiftModal: true
                                                            }
                                                        )

                                                    }
                                                }
                                            >
                                                <FontAwesomeIcon icon={faCheckCircle} className={"mr-1"} /> Create Shift
                                            </button>
                                        )}
                                        {auth.hasPermissionV2(AppPermissions.SCHEDULE_PUBLISH) && (
                                            <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={() => this.ScheduleFilterValidation(2)}>
                                                <FontAwesomeIcon icon={faCheckCircle} className={"mr-1 tick-icon"} /> Publish Schedule
                                            </button>
                                        )}
                                        <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={
                                                    () => {
                                                        document.body.classList.remove("scheduler-shift-wrap");
                                                        this.setState({ showAsignConfirmationModal: true })
                                                    }
                                                }
                                            >
                                            <FontAwesomeIcon icon={faCheckCircle} className={"mr-1"} /> Assign Shifts
                                        </button>

                                        <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                                            <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} />
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <ConfirmationModal
                    message={GENERATE_SCHEDULE_CONFIRMATION_MSG()}
                    showModal={this.state.showGenerateConfirmationModal}
                    handleYes={() => this.generateSchedule()}
                    handleNo={() => {
                        this.setState({ showGenerateConfirmationModal: false });
                    }}
                    isGenerate={true}
                />
                <ConfirmationModal
                    message={PUBLISH_SCHEDULE_CONFIRMATION_MSG()}
                    showModal={this.state.showPublishConfirmationModal}
                    handleYes={() => this.publishSchedule()}
                    handleNo={() => {
                        this.setState({ showPublishConfirmationModal: false });
                    }}
                />
                {this.state.showAddShiftModal && (
                    <div id="Edit-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <CreateShift
                                ScheduleId={this.state.scheduleId}
                                onCloseModal={() => this.setState({ showAddShiftModal: false })}
                                onOpenModal={() => this.setState({ showAddShiftModal: true })}
                                handleGetSchedule={this.props.handleGetSchedule}
                            />
                        </Dialog>
                    </div>
                )}
                {this.state.showAsignConfirmationModal && this.props.data.departmentId && (
                    <div id="add-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <AssignScheduleShift
                                onCloseModal={() => this.setState({ showAsignConfirmationModal: false })}
                                onOpenModal={() => this.setState({ showAsignConfirmationModal: true })}
                                departmentId={departmentId}
                                scheduleId={this.props.data.scheduleId}
                                handleGetSchedule={this.props.handleGetSchedule}
                            />
                        </Dialog>
                    </div>
                )}

            </div>
        );
    }
}

export default FilterInformation;